<template>
    <div class="product-fabric-impression-video">
        <CommonComponentsVideoPlayer
            class="impression-video-pc"
            :sources="[
                {
                    src: data.fabricBallVideo.pc,
                    type: 'video/mp4',
                },
            ]"
            :poster="data.fabricBallVideo.pcPoster"
        />
        <CommonComponentsVideoPlayer
            class="impression-video-mobile"
            :sources="[
                {
                    src: data.fabricBallVideo.mobile,
                    type: 'video/mp4',
                },
            ]"
            :poster="data.fabricBallVideo.mobilePoster"
        />
    </div>
</template>

<script lang="ts" setup>
    import pcVideo from '@assets/Video/products/fabric/impression.mp4';
    import mobileVideo from '@assets/Video/products/fabric/impressionMobile.mp4';
    import pcVideoPoster from '@assets/Video/products/fabric/impression.jpg';
    import mobileVideoPoster from '@assets/Video/products/fabric/impressionMobile.jpg';
    import { matchMobile } from '~~/composables/useMatchRules.ts';
    const isMobile = ref(false);
    const data = reactive({
        fabricBallVideo: {
            pc: pcVideo,
            pcPoster: pcVideoPoster,
            mobile: mobileVideo,
            mobilePoster: mobileVideoPoster,
        },
    });

    onMounted(() => {
        isMobile.value = matchMobile();
    });
</script>

<style lang="less" scoped>
    .product-fabric-impression-video {
        width: .convert(1360px) [ @vw];
        height: .convert(850px) [ @vw];
        video {
            z-index: 1;
            width: 100%;
        }

        .impression-video-mobile {
            display: none;
        }

        @media (max-width: @screen-mobile-width) {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .impression-video-pc {
                display: none;
            }
            .impression-video-mobile {
                display: block;
            }
        }
    }
</style>
